import React from "react";

import { Card, Button } from "antd";
import "../sass/ClienteCard.scss";

import moment from 'moment'

export default function ClienteCard({ cliente, selectCliente }) {

  let source = cliente._source;


  const dateFormat = "DD/MM/YYYY";
  return (
    <div id="ClienteCard">
      <Card
        key={source.cardId}
        title={<b> {source.cardId} </b>}
        extra={<Button type="primary" onClick={() => selectCliente(cliente)}> Dettagli </Button>}
        style={{ width: 300, borderRadius: 10 }}
      >
        <h3>
          <b>{source.ragso1} {source.ragso2}</b>
        </h3>
        <p><b>Soglia Premi</b> : {source.sogliaPremi}</p>
        <p><b>Codice Negozio</b> : {source.codiceNegozio}</p>
        <p><b>Comune </b> : {source.comune}</p>
        <p><b>Data Caricamento </b>: {moment(source.dataCaricamento).format(dateFormat)}</p>
        <p><b>Aggiornato il </b>: {moment(source.lastUpdate).format(dateFormat)}</p>
      </Card>
    </div>
  );
}
